import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { RouteHelpers } from '@/mixins';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const ScriveEditSigningParty = () =>
  import(
    /* webpackChunkName: "ScriveEditSigningParty" */
    '@/views/configuration/scrive/ScriveEditSigningParty.vue'
  );

const ScriveAddSigningParty = () =>
  import(
    /* webpackChunkName: "ScriveAddSigningParty" */
    '@/views/configuration/scrive/ScriveAddSigningParty.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: 'scrivetemplates',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'Scrive Templates'
};

const treeView = {
  treeView: ConfigurationTreeView
};

export const SigningPartyRoutes = [
  {
    ...Configuration.Scrive.SigningParty.Edit,
    components: {
      default: ScriveEditSigningParty,
      ...treeView
    },
    meta,
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Scrive.Template.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['documentTypeId', 'templateId', 'id']);
    }
  },
  {
    ...Configuration.Scrive.SigningParty.Add,
    components: {
      default: ScriveAddSigningParty,
      ...treeView
    },
    meta,
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Scrive.Template.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['documentTypeId', 'templateId']);
    }
  }
];
